import React from 'react'
import CadastroProduto from '../../components/produtos/cadastroProduto/CadastroProduto'

function RegistroProduto() {
  return (
    <CadastroProduto/>
  )
}

export default RegistroProduto